import { makeAutoObservable } from 'mobx'
export interface todoDataDto {
    id: number;
    text: string;
    isFinished: boolean;
}
class TestStore{
    test:string='TestStore-test'
    constructor(){
        makeAutoObservable(this);
    }
    changeTest(test:string = 'TestStore-test'){
        this.test = test;
    }
}
export default new TestStore();